export default __webpack_public_path__ + "static/media/atul.923fddf3.jpeg";